import { render, staticRenderFns } from "./MeetingClosureModuleKpis.vue?vue&type=template&id=5147f374&"
import script from "./MeetingClosureModuleKpis.vue?vue&type=script&lang=js&"
export * from "./MeetingClosureModuleKpis.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports